import { render, staticRenderFns } from "./ContentWelcome.vue?vue&type=template&id=511bd324&scoped=true&"
import script from "./ContentWelcome.vue?vue&type=script&lang=js&"
export * from "./ContentWelcome.vue?vue&type=script&lang=js&"
import style0 from "./ContentWelcome.vue?vue&type=style&index=0&id=511bd324&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511bd324",
  null
  
)

export default component.exports